import React from 'react';
import Lottie from 'react-lottie-player';
import loaderJson from '../../assets/images/loader.json';

function Preloader({isComponentLoader = false}) {
  return (
    <div id='preloader' className={'d-flex justify-content-center align-items-center '+(isComponentLoader ? 'position-static z-3 inner-preloader' : '')}>
      {/* <Spinner style={{
        height: '3rem',
        width: '3rem',
        borderColor: "#e834eb",
        borderRightColor: "transparent"
      }} /> */}
      <Lottie
        loop
        animationData={loaderJson}
        play
        style={{ width: 300, height: 300 }}
      />
    </div>
  )
}

export default Preloader
